import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { TransitNonArrivalData } from '@e-origin/contracts';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

interface TransitProps {
  id: string;
  data: TransitNonArrivalData;
}

export const useSendNonArrivalInfo = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id, data }: TransitProps) => {
      const result = await apiClient.transit.sendNonArrivalInfo.mutation({ body: { transitId: id, data } });
      if (result.status !== 200) throw result.body;
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['transits'] });
      queryClient.invalidateQueries({ queryKey: ['transit', variables.id] });
      toast.success(`Non-arrival info was sent!`);
    },
    onError: (error) => {
      showErrorToast(error, `Error sending the non-arrival info!`);
    },
  });
};
